/**
 * Sparkbar.js
 *
 * @class   Sparkbar
 * @author  Dan Goldshlack
 *
 */

import React from 'react';
import D3 from 'd3';

export default React.createClass({

	displayName: 'Sparkbar',

	propTypes: {

	},

	render() {

		return <h3>Sparkbar</h3>

	}

});



/** WEBPACK FOOTER **
 ** ./src/charts/sparkbar/SparkBar.js
 **/